const state = {
    types: [],
};

const getters = {
    EXCLUDE_MODULE: state => state.types
};

export default {
    state,
    getters
};
